import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect } from 'react';
import { useService } from '~/services/service.base';
import { UIService } from '~/services/service.ui';
import { Breadcrumb } from '~/views/molecules/nav.breadcrumbs';
import { PageWrapper } from '~/views/organisms/wrapper.page';
import { ServiceShelve } from '~/services/service.shelve';
import { ServiceBooks } from '~/services/service.books';
import { ServiceCommunity } from '~/services/service.community';
import { Grid, IconButton, Typography } from '@mui/material';
import { CalendarIcon } from '~/views/atoms/svg-icons';
import { PageHeader } from '~/views/molecules/page.header';
import { t } from 'i18next';
import { Column } from '~/views/atoms/boxes';
import { Shelves } from '~/views/organisms/shelves';
import { AuthService } from '~/services/service.auth';
import { ServiceDateFilter } from '~/services/service.date.filter';
import { DateFilter } from '~/views/organisms/date-filter';
import { ServiceBookCover } from '~/services/service.book.cover';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { EBreadcrumbKey } from '~/shared/types';
export const PageFundsBooks = observer(() => {
    const { breadcrumbsSvc } = useService(UIService);
    const shelvesService = useService(ServiceShelve);
    const booksService = useService(ServiceBooks);
    const communityService = useService(ServiceCommunity);
    const authService = useService(AuthService);
    const filterDateService = useService(ServiceDateFilter);
    const booksCoverService = useService(ServiceBookCover);
    const navigate = useNavigate();
    const clickBookHandler = useCallback((book) => {
        booksService.openBookService.handleOpen();
        booksCoverService.getBookSheets(communityService.currentCommunity.id, book.id);
        booksService.getBook(communityService.currentCommunity.id, book.id);
        navigate(ROUTES.FUNDS.BOOKS.BOOK_COVER.path);
    }, [booksCoverService, booksService, communityService.currentCommunity.id, navigate]);
    const clickDateFilterHandler = useCallback(() => {
        filterDateService.openDateFilterService.handleOpen();
    }, [filterDateService.openDateFilterService]);
    const filterDataHandler = useCallback((value) => {
        booksService.setSelectedYear(value.filterOption);
        booksService.filterBooksByYear(value.filterOption);
        filterDateService.openDateFilterService.handleClose();
    }, [booksService, filterDateService.openDateFilterService]);
    useEffect(() => {
        if (!communityService.currentCommunity) {
            return;
        }
        const isPublic = () => (!authService.isLogged ? 1 : undefined);
        shelvesService.getShelves(communityService.currentCommunity.id, { is_public: isPublic() });
        booksService.getBooks(communityService.currentCommunity.id, { is_public: isPublic() });
    }, [authService.isLogged, booksService, communityService.currentCommunity, filterDateService, shelvesService]);
    useEffect(() => {
        breadcrumbsSvc.use([
            {
                key: EBreadcrumbKey.repository,
            },
        ]);
    }, [breadcrumbsSvc]);
    return (_jsxs(PageWrapper, { children: [_jsx(Breadcrumb.Nav, { children: breadcrumbsSvc.children }), _jsxs(PageHeader, { justifyContent: "flex-start", children: [_jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Typography, { variant: "h2", children: t('BOOK_PAGE_TITLE') }) }), _jsx(Grid, { container: true, flexDirection: "column", children: _jsx(Grid, { container: true, justifyContent: "flex-end", children: _jsx(IconButton, { onClick: clickDateFilterHandler, color: "inherit", children: _jsx(CalendarIcon, {}) }) }) })] }), _jsx(Column, { py: 1.5, px: 1.5, gap: 2, children: _jsx(Shelves, { shelves: shelvesService.shelves.toJSON(), clickBookHandler: clickBookHandler }) }), filterDateService.openDateFilterService.open && (_jsx(DateFilter, { onSubmitHandler: filterDataHandler, defaultYear: booksService.selectedYear, years: booksService.years.toJSON() }))] }));
});
